// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"07fe460c","84":"d4f0b7db","217":"857612e2","336":"4a13a1c7","522":"a5d5a2bb","598":"b8c4bc35","609":"48ebb8d5","732":"27d298c7","880":"0adf895a"}[chunkId] + ".chunk.css";
};